<template>
  <div class="model-layout">
    <div class="tools">
      <slot name="toolbar" />
    </div>
    <div class="nav">
      <slot name="navigation" />
    </div>
    <div class="scene">
      <slot name="scene" />
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.model-layout {
  display: grid;
  grid-template-columns: bu(5) 1fr 1fr;
  grid-template-rows: bu(6) 1fr;
  height: 100%;
  width: 100%;
  grid-template-areas:
    'tools tools tools'
    'nav scene scene';
}

.tools {
  grid-area: tools;
  position: relative;
}
.nav {
  grid-area: nav;
  position: relative;
}
.scene {
  align-items: center;
  display: flex;
  grid-area: scene;
  overflow: hidden;
}
</style>
